import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const getSharedUsersOnMovement = (id: string): ReturnType => {
    return Request.get(`/workouts/movements/${id}/users`);
};

export default getSharedUsersOnMovement;
